import { useState } from "react";
import api from "../../config/axios";
import Swal from "sweetalert2";

export function autoCompleteClientes() {
    const [inputPesquisaCliente, setInputPesquisaCliente] = useState("");
    const [clientesOptions, setClientesOptions] = useState([]);

    const handleAutoCompleteClientes = async (value) => {
        setInputPesquisaCliente(value);

        try {
            const url = value.length > 0
                ? `/pessoas/clientes?page=1&limit=10&nome=${value}`
                : `/pessoas/clientes?page=1&limit=10`;

            const response = await api.get(url);

            const clientes = response.data.clientes.map((cliente) => ({
                value: cliente.id,
                label: cliente.nome,
            }));

            setClientesOptions(clientes);
        } catch (error) {
            Swal.fire("Erro", "Não foi possível buscar clientes.", "error");
        }
    };

    const handleFocusClientes = async () => {
        if (clientesOptions.length === 0) {
            try {
                const response = await api.get(`/pessoas/clientes?page=1&limit=10`);

                const clientes = response.data.clientes.map((cliente) => ({
                    value: cliente.id,
                    label: cliente.nome,
                }));

                setClientesOptions(clientes);
            } catch (error) {
            }
        }
    };

    return { inputPesquisaCliente, clientesOptions, handleAutoCompleteClientes, handleFocusClientes };
}

export function autoCompleteServicos() {
    const [inputPesquisaServico, setInputPesquisaServico] = useState("");
    const [servicosOptions, setServicosOptions] = useState([]);

    const handleAutoCompleteServicos = async (value) => {
        setInputPesquisaServico(value);

        try {
            const url = value.length > 0
                ? `/servicos?page=1&limit=10&nome=${value}`
                : `/servicos?page=1&limit=10`;

            const response = await api.get(url);

            const servicos = response.data.records.map((servico) => ({
                value: servico.id_servico,
                label: servico.nome,
                tempo: servico.tempo,
                preco: servico.preco
            }));

            setServicosOptions(servicos);
        } catch (error) {
            Swal.fire('Erro', 'Não foi possível buscar serviços.', 'error');
        }
    };

    const handleFocusServicos = async () => {
        if (servicosOptions.length === 0) {
            try {
                const response = await api.get(`/servicos?page=1&limit=10`);
                const servicos = response.data.records.map((servico) => ({
                    value: servico.id_servico,
                    label: servico.nome,
                    tempo: servico.tempo,
                    preco: servico.preco
                }));
                setServicosOptions(servicos);
            } catch (error) {
            }
        }
    };

    return { inputPesquisaServico, servicosOptions, handleAutoCompleteServicos, handleFocusServicos };
}

export function autoCompleteColaboradores() {
    const [inputPesquisaColaborador, setInputPesquisaColaborador] = useState("");
    const [colaboradoresOptions, setColaboradoresOptions] = useState([]);

    const handleAutoCompleteColaboradores = async (value) => {
        setInputPesquisaColaborador(value);

        try {
            const url = value.length > 0
                ? `/pessoas/colaboradores?page=1&limit=10&nome=${value}`
                : `/pessoas/colaboradores?page=1&limit=10`;

            const response = await api.get(url);

            const colaboradores = response.data.colaboradores.map((colaborador) => ({
                value: colaborador.id,
                label: colaborador.nome
            }));

            setColaboradoresOptions(colaboradores);
        } catch (error) {
            Swal.fire('Erro', 'Não foi possível buscar colaboradores.', 'error');
        }
    };

    const handleFocusColaboradores = async () => {
        if (colaboradoresOptions.length === 0) {
            try {
                const response = await api.get(`/pessoas/colaboradores?page=1&limit=10`);
                const colaboradores = response.data.colaboradores.map((colaborador) => ({
                    value: colaborador.id,
                    label: colaborador.nome
                }));
                setColaboradoresOptions(colaboradores);
            } catch (error) {
            }
        }
    };

    return { inputPesquisaColaborador, colaboradoresOptions, handleAutoCompleteColaboradores, handleFocusColaboradores };
}

export function autoCompleteColaboradoresComanda() {
    const [inputPesquisaColaborador, setInputPesquisaColaborador] = useState("");
    const [colaboradoresOptions, setColaboradoresOptions] = useState([]);

    const handleAutoCompleteColaboradores = async (value, item) => {
        setInputPesquisaColaborador(value);

        try {
            if (item.tipo_item == 'servico') {
                const response = await api.get(`/servicos/details/${item.servico.value}`);

                const colaboradores = response.data.colaboradoresAssociados.records.map((colaborador) => ({
                    value: colaborador.id_pessoa,
                    label: colaborador.pessoa.nome
                }));

                setColaboradoresOptions(colaboradores);
            }
            else {
                const url = value.length > 0
                    ? `/pessoas/colaboradores?page=1&limit=10&nome=${value}`
                    : `/pessoas/colaboradores?page=1&limit=10`;

                const response = await api.get(url);

                const colaboradores = response.data.colaboradores.map((colaborador) => ({
                    value: colaborador.id,
                    label: colaborador.nome
                }));

                setColaboradoresOptions(colaboradores);
            }
        } catch (error) {
            Swal.fire('Erro', 'Não foi possível buscar colaboradores.', 'error');
        }
    };

    const handleFocusColaboradoresComanda = async (item) => {
        if (colaboradoresOptions.length === 0 && item) {
            try {
                if (item.tipo_item == 'servico' && item.servico) {
                    const response = await api.get(`/servicos/details/${item.servico.value}`);
                    const colaboradores = response.data.colaboradoresAssociados.records.map((colaborador) => ({
                        value: colaborador.id_pessoa,
                        label: colaborador.pessoa.nome
                    }));
                    setColaboradoresOptions(colaboradores);
                } else {
                    const response = await api.get(`/pessoas/colaboradores?page=1&limit=10`);
                    const colaboradores = response.data.colaboradores.map((colaborador) => ({
                        value: colaborador.id,
                        label: colaborador.nome
                    }));
                    setColaboradoresOptions(colaboradores);
                }
            } catch (error) {
            }
        }
    };

    return { inputPesquisaColaborador, colaboradoresOptions, handleAutoCompleteColaboradores, handleFocusColaboradoresComanda };
}

export function autoCompleteProdutos() {
    const [inputPesquisaProduto, setInputPesquisaProduto] = useState("");
    const [produtosOptions, setProdutosOptions] = useState([]);

    const handleAutoCompleteProdutos = async (value) => {
        setInputPesquisaProduto(value);

        try {
            const url = value.length > 0
                ? `/produtos?page=1&limit=10&nome=${value}`
                : `/produtos?page=1&limit=10`;

            const response = await api.get(url);

            const produtos = response.data.records.map((produto) => ({
                value: produto.id_produto,
                label: produto.nome,
                preco: produto.valor_venda,
                estoque_atual: produto.estoque_atual,
                estoque_minimo: produto.estoque_minimo
            }));

            setProdutosOptions(produtos);
        } catch (error) {
            Swal.fire('Erro', 'Não foi possível buscar produtos.', 'error');
        }
    };

    const handleFocusProdutos = async () => {
        if (produtosOptions.length === 0) {
            try {
                const response = await api.get(`/produtos?page=1&limit=10`);
                const produtos = response.data.records.map((produto) => ({
                    value: produto.id_produto,
                    label: produto.nome,
                    preco: produto.valor_venda,
                    estoque_atual: produto.estoque_atual,
                    estoque_minimo: produto.estoque_minimo
                }));
                setProdutosOptions(produtos);
            } catch (error) {
            }
        }
    };

    return { inputPesquisaProduto, produtosOptions, handleAutoCompleteProdutos, handleFocusProdutos };
}

export function autoCompleteBancos() {
    const [inputPesquisaBanco, setInputPesquisaBanco] = useState("");
    const [bancosOptions, setBancosOptions] = useState([]);

    const handleAutoCompleteBancos = async (value) => {
        setInputPesquisaBanco(value);

        try {
            const url = value.length > 0
                ? `/bancos?page=1&limit=10&nome=${value}`
                : `/bancos?page=1&limit=10`;

            const response = await api.get(url);

            const bancos = response.data.records.map((banco) => ({
                value: banco.id,
                label: banco.nome
            }));

            setBancosOptions(bancos);
        } catch (error) {
            Swal.fire('Erro', 'Não foi possível buscar bancos.', 'error');
        }
    };

    const handleFocusBancos = async () => {
        if (bancosOptions.length === 0) {
            try {
                const response = await api.get(`/bancos?page=1&limit=10`);
                const bancos = response.data.records.map((banco) => ({
                    value: banco.id,
                    label: banco.nome
                }));
                setBancosOptions(bancos);
            } catch (error) {
            }
        }
    };

    return { inputPesquisaBanco, bancosOptions, handleAutoCompleteBancos, handleFocusBancos };
}

export function autoCompleteGestoras() {
    const [inputPesquisaGestora, setInputPesquisaGestora] = useState("");
    const [gestorasOptions, setGestorasOptions] = useState([]);

    const handleAutoCompleteGestoras = async (value) => {
        setInputPesquisaGestora(value);

        try {
            const url = value.length > 0
                ? `/gestoras?page=1&limit=10&nome=${value}`
                : `/gestoras?page=1&limit=10`;

            const response = await api.get(url);

            const gestoras = response.data.gestoras.map((gestora) => ({
                value: gestora.id,
                label: gestora.nome
            }));

            setGestorasOptions(gestoras);
        } catch (error) {
            Swal.fire('Erro', 'Não foi possível buscar gestoras.', 'error');
        }
    };

    const handleFocusGestoras = async () => {
        if (gestorasOptions.length === 0) {
            try {
                const response = await api.get(`/gestoras?page=1&limit=10`);
                const gestoras = response.data.gestoras.map((gestora) => ({
                    value: gestora.id,
                    label: gestora.nome
                }));
                setGestorasOptions(gestoras);
            } catch (error) {
            }
        }
    };

    return { inputPesquisaGestora, gestorasOptions, handleAutoCompleteGestoras, handleFocusGestoras };
}

export function autoCompleteUnidades() {
    const [inputPesquisaUnidade, setInputPesquisaUnidade] = useState("");
    const [unidadesOptions, setUnidadesOptions] = useState([]);

    const handleAutoCompleteUnidades = async (value, gestoraId) => {
        setInputPesquisaUnidade(value);

        if (!gestoraId) {
            setUnidadesOptions([]);
            return;
        }

        try {
            const url = value.length > 0
                ? `/gestoras/${gestoraId}/unidades?page=1&limit=10&nome=${value}`
                : `/gestoras/${gestoraId}/unidades?page=1&limit=10`;

            const response = await api.get(url);

            const unidades = response.data.unidades.map((unidade) => ({
                value: unidade.id,
                label: unidade.nome
            }));

            setUnidadesOptions(unidades);
        } catch (error) {
            Swal.fire('Erro', 'Não foi possível buscar unidades.', 'error');
        }
    };

    const handleFocusUnidades = async (gestoraId) => {
        if (unidadesOptions.length === 0 && gestoraId) {
            try {
                const response = await api.get(`/gestoras/${gestoraId}/unidades?page=1&limit=10`);
                const unidades = response.data.unidades.map((unidade) => ({
                    value: unidade.id,
                    label: unidade.nome
                }));
                setUnidadesOptions(unidades);
            } catch (error) {
            }
        }
    };

    return { inputPesquisaUnidade, unidadesOptions, handleAutoCompleteUnidades, handleFocusUnidades };
}

export function autoCompleteCategoriasFinanceiras() {
    const [inputPesquisaCategoria, setInputPesquisaCategoria] = useState("");
    const [categoriasOptions, setCategoriasOptions] = useState([]);

    const handleAutoCompleteCategoriasFinanceiras = async (value) => {
        setInputPesquisaCategoria(value);

        try {
            const url = value.length > 0
                ? `/categorias-financeiras?page=1&limit=10&nome=${value}`
                : `/categorias-financeiras?page=1&limit=10`;

            const response = await api.get(url);

            const categorias = response.data.records.map((categoria) => ({
                value: categoria.id,
                label: categoria.nome
            }));

            setCategoriasOptions(categorias);
        } catch (error) {
            Swal.fire('Erro', 'Não foi possível buscar categorias financeiras.', 'error');
        }
    };

    const handleFocusCategoriasFinanceiras = async () => {
        if (categoriasOptions.length === 0) {
            try {
                const response = await api.get(`/categorias-financeiras?page=1&limit=10`);
                const categorias = response.data.records.map((categoria) => ({
                    value: categoria.id,
                    label: categoria.nome
                }));
                setCategoriasOptions(categorias);
            } catch (error) {
            }
        }
    };

    return { inputPesquisaCategoria, categoriasOptions, handleAutoCompleteCategoriasFinanceiras, handleFocusCategoriasFinanceiras };
}

export function autoCompleteCentrosDeCusto() {
    const [inputPesquisaCentroCusto, setInputPesquisaCentroCusto] = useState("");
    const [centrosCustoOptions, setCentrosCustoOptions] = useState([]);

    const handleAutoCompleteCentrosDeCusto = async (value) => {
        setInputPesquisaCentroCusto(value);

        try {
            const url = value.length > 0
                ? `/centros-de-custo?page=1&limit=10&nome=${value}`
                : `/centros-de-custo?page=1&limit=10`;

            const response = await api.get(url);

            const centros = response.data.records.map((centro) => ({
                value: centro.id,
                label: centro.nome
            }));

            setCentrosCustoOptions(centros);
        } catch (error) {
            Swal.fire('Erro', 'Não foi possível buscar centros de custo.', 'error');
        }
    };

    const handleFocusCentrosDeCusto = async () => {
        if (centrosCustoOptions.length === 0) {
            try {
                const response = await api.get(`/centros-de-custo?page=1&limit=10`);
                const centros = response.data.records.map((centro) => ({
                    value: centro.id,
                    label: centro.nome
                }));
                setCentrosCustoOptions(centros);
            } catch (error) {
            }
        }
    };

    return { inputPesquisaCentroCusto, centrosCustoOptions, handleAutoCompleteCentrosDeCusto, handleFocusCentrosDeCusto };
}

export function autoCompleteCategoriasReceita() {
    const [inputPesquisaCategoria, setInputPesquisaCategoria] = useState("");
    const [categoriasOptions, setCategoriasOptions] = useState([]);

    const handleAutoCompleteCategoriasReceita = async (value) => {
        setInputPesquisaCategoria(value);

        try {
            const url = value.length > 0
                ? `/categorias-financeiras?page=1&limit=10&nome=${value}&tipo_contabil=receita&vai_dre=S`
                : `/categorias-financeiras?page=1&limit=10&tipo_contabil=receita&vai_dre=S`;

            const response = await api.get(url);

            const categorias = response.data.records.map((categoria) => ({
                value: categoria.id,
                label: categoria.nome
            }));

            setCategoriasOptions(categorias);
        } catch (error) {
            Swal.fire('Erro', 'Não foi possível buscar categorias de receita.', 'error');
        }
    };

    const handleFocusCategoriasReceita = async () => {
        if (categoriasOptions.length === 0) {
            try {
                const response = await api.get(`/categorias-financeiras?page=1&limit=10&tipo_contabil=receita&vai_dre=S`);
                const categorias = response.data.records.map((categoria) => ({
                    value: categoria.id,
                    label: categoria.nome
                }));
                setCategoriasOptions(categorias);
            } catch (error) {
            }
        }
    };

    return { inputPesquisaCategoria, categoriasOptions, handleAutoCompleteCategoriasReceita, handleFocusCategoriasReceita };
}

export function autoCompleteFornecedores() {
    const [inputPesquisaFornecedor, setInputPesquisaFornecedor] = useState("");
    const [fornecedoresOptions, setFornecedoresOptions] = useState([]);

    const handleAutoCompleteFornecedores = async (value) => {
        setInputPesquisaFornecedor(value);

        try {
            const url = value.length > 0
                ? `/pessoas/fornecedores?page=1&limit=10&nome=${value}`
                : `/pessoas/fornecedores?page=1&limit=10`;

            const response = await api.get(url);

            const fornecedores = response.data.fornecedores.map((fornecedor) => ({
                value: fornecedor.id,
                label: fornecedor.dadosFornecedor?.nome_fantasia || fornecedor.nome || ''
            }));

            setFornecedoresOptions(fornecedores);
        } catch (error) {
            Swal.fire("Erro", "Não foi possível buscar fornecedores.", "error");
        }
    };

    const handleFocusFornecedores = async () => {
        if (fornecedoresOptions.length === 0) {
            try {
                const response = await api.get(`/pessoas/fornecedores?page=1&limit=10`);
                const fornecedores = response.data.fornecedores.map((fornecedor) => ({
                    value: fornecedor.id,
                    label: fornecedor.dadosFornecedor?.nome_fantasia || fornecedor.nome || ''
                }));
                setFornecedoresOptions(fornecedores);
            } catch (error) {
            }
        }
    };

    return { inputPesquisaFornecedor, fornecedoresOptions, handleAutoCompleteFornecedores, handleFocusFornecedores };
}

